import * as React from 'react';
import IRegelverkstolkningerProps from './IRegelverkstolkningerProps';
import Pagination from '../SharedComponents/Pagination/Pagination';
import ResultPane from './ResultPane/ResultPane';
import NoResultPane from '../SharedComponents/NoResultPane/NoResultPane';
import Filter from '../SharedComponents/Filter/Filter';
import SearchBox from '../SharedComponents/SearchBox/SearchBox';
import SearchNavigationTabs from '../SharedComponents/SearchNavigationTabs/SearchNavigationTabs';
import FiltersSelected from '../SharedComponents/FiltersSelected/FiltersSelected';
import './Regelverkstolkninger.scss'
import { getFilterNames } from '../../utils'
import { getResults, getResultsAll, SearchQuery, SearchSource } from './getResults';
import IRefiners from '../../Models/IRefiners';
import { DisplayFormat } from '../../Models/DisplayFormat';
import { SearchPageLayout } from '../../Models/SearchLayout';
import { Resultnumber } from '../SharedComponents/Resultnumber';
import { toggleToTopComponent } from '../SharedComponents/MoveToTop/MoveToTop';
import { SuggestionBox } from '../SharedComponents/SuggestionBox';
import { InformationMessageBox } from '../SharedComponents/InformationMessageBox';
import { getUrlParameter, setUrlParameter, removeAllFilterParams, getFilterParametersFromUrl, removeHashFromUrl } from '../../utils/urlParamHelper';
import { ensureSelectedFilterValues, getNumberOfActiveFilters, emptyFilterCheckboxes, getFilterNamesWithCheckedItems, updateFilterCounts, updateFilterCountsExcept, updateFilterCountsExceptMany } from '../../utils/refinerHelpers';
import { getInfoMsg } from '../../utils/searchHelpers';
import { getCurrentDisplayFormat } from '../../utils/generalHelpers';
import { LogWarning } from '../../utils/logging';
import IRegelverkstolkningerState from './IRegelverkstolkningerState';
import { IRegelverkResult } from '../../Models/IResult';
import SortBySuggestion from "../SharedComponents/Suggestion/SortBySuggestion";
import { Button, Heading, ListUnordered, ListItem } from '@udir-design/react/beta';
import { ChevronDownIcon, ChevronUpIcon } from '@udir-design/icons';
import '../../udirsok-searchbox-redesign.scss'

export default class Regelverkstolkninger extends React.Component<IRegelverkstolkningerProps, IRegelverkstolkningerState> {
    private resultPerPage = 10;
    private refinementFilters = ['Tema','innholdstype','gyldighet'];
    private predefinedFilterNames = ['gyldighet'];
    private refinementFiltersShowAllValuesUrlParamName = 'filtervalues';
    private queryParameter = "query";

    public constructor(props: IRegelverkstolkningerProps) {
        super(props);
        // Removing hash (#) from URL if exists
        if(window.location.hash && window.location.hash !== ""){
            removeHashFromUrl(window.location.href);
        }
        //Set up initial querydata from parameters
        let queryParameter = getUrlParameter(this.queryParameter);
        if(getUrlParameter("k") !== undefined){
            this.queryParameter = "k"
            queryParameter = getUrlParameter(this.queryParameter);
        }
        const initialPageNumber = getUrlParameter('page');
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);
        
        const initialSource = getUrlParameter('kilde');
        const initialHiddenFilterNames = (initialSource && initialSource==="All") ? [] : ['gyldighet'];
        let enumInitialSource;
        if (!initialSource || initialSource === 'Default') {
            enumInitialSource = SearchSource.Default;
        } else {
            enumInitialSource = SearchSource.All;
        }
        this.state = {
            currentPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : 1,
            initialQuery: queryParameter,
            displayFormat: getCurrentDisplayFormat(),
            initialPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : undefined,
            initialFilters: filterParameters ? filterParameters : undefined,
            searchSource: enumInitialSource,
            hiddenFilterNames: initialHiddenFilterNames,
            showSearchTips: false,
            isInitialSearch: true
        }
    }

    public componentDidMount() {
        window.addEventListener("resize", _ => this._onWindowResize());
        window.onpopstate = () => this.onStatePopped();
        window.addEventListener("pageshow", (event: PageTransitionEvent) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
        this.setupAndRunInitialQuery();
        getInfoMsg().then(result => {
            if(result){
                if(result.regelverkstolkninger){
                    this.setState({ informationMessage: result.regelverkstolkninger.title });
                }
                for (var i = 0; i < result.length; i++) {
                    if(result[i].hasOwnProperty("regelverkstolkninger")){
                        this.setState({ informationMessage: result[i].regelverkstolkninger.title });
                        break;
                    }
                }
            }
        });
    }

    public componentDidUpdate() {
        toggleToTopComponent(this.state.results && this.state.results.items.length > 0);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", _ => this._onWindowResize());
        this._onWindowResize();
    }

    public render() {
        const numberOfResults = this.findNumberOfResults();
        const numberOfPages = this.findNumberOfPages();
        const numberOfActiveFilters = getNumberOfActiveFilters(this.state.filter, this.refinementFilters);
        const isDesktop = this.state.displayFormat === DisplayFormat.Desktop;
        const searchLayout = SearchPageLayout.FilterLeftResultsRight;
        const searchboxClass = (isDesktop && searchLayout===0) ? "searchBoxBanner filterLeftAligned" : "searchBoxBanner";
        const searchboxClassWithToggle = `${searchboxClass} ${this.state.showSearchTips ? 'tips-open' : 'tips-closed'}`;
        const resultinformationClass = isDesktop ? "searchVerticals" : "searchVerticals";
        const filterClass = (isDesktop && searchLayout===0) ? "filters" : "filters";
        const searchresultsClass = (isDesktop && searchLayout===0) ? "uds-results" : "uds-results";
        const shouldDisplayFilters =  (this.state.results && this.state.results.items && this.state.results.items.length > 0) || (this.state.filter && getNumberOfActiveFilters(this.state.filter, this.refinementFilters) > 0);
        const showAutocomplete = true;
        return (
            <div id="main-content" className="searchContainer">
                <div className='searchBoxBannerOuter'>
                    <div className={`${searchboxClassWithToggle}`}>
                        <div className="searchBoxBannerContent">
                            <div className="searchBoxContent">
                                <div className="leftBarSearchBox">
                                    <div className="searchHeader">
                                        <Heading className='searchText' level={1} data-size={isDesktop ? 'lg' : 'md'}>
                                            Søk i regelverk
                                        </Heading>
                                    </div>
                                    <SearchBox
                                        initialQuery={this.state.initialQuery ? this.state.initialQuery : ""}
                                        onSearch={(query, searchAsYouType) => this.onSearch(query, searchAsYouType)}
                                        newQuery={this.state.newStateQuery}
                                        placeholderText="Søk etter lov, forskrift, tolkning, rundskriv, med mer"
                                        autocomplete={showAutocomplete}
                                        searchVertical="Regelverkstolkninger" />

                                </div>
                                <div className="rightBarSearchBox">
                                    {/* 
                                    <Button
                                        data-size="md"
                                        variant='tertiary'
                                        color='neutral'
                                        className="SearchTipsButton"
                                        onClick={() => this.setState({ showSearchTips: !this.state.showSearchTips })}
                                        aria-expanded={!!this.state.showSearchTips}
                                        aria-controls="SearchTipsContent"
                                    >
                                        Søketips
                                        {this.state.showSearchTips ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </Button>
                                    {this.state.showSearchTips && (
                                        <div className="SearchTipsContent" id="SearchTipsContent">
                                            <div className='SearchTipsContentText'>
                                                <ListUnordered>
                                                    <ListItem>
                                                        Enkelte tolkninger og veiledninger til regelverk som ikke lenger er gyldig, kan finnes her ved å bruke filtreringen under filteret «Gyldighet». Kryss av for Utgått innhold for å se dette.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan angi flere ord innenfor anførselsestegn («…») for å søke etter disse ordene i den bestemte, angitte rekkefølgen. For eksempel søk på «trygt og godt skolemiljø» for å finne søketreff med ordene i nøyaktig den rekkefølgen.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan bruke - for å ekskludere ord. For eksempel søke på: <em>regelverk -privatskole</em> for å finne alle regelverk som ikke har med ordet privatskole
                                                    </ListItem>
                                                </ListUnordered>
                                            </div>
                                        </div>
                                    )}
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`${resultinformationClass}`}>
                    <SearchNavigationTabs currentTab="regelverk" searchQuery={this.state.searchboxQuery} />
                    {!isDesktop && shouldDisplayFilters && this.state.filter && (
                        <Filter 
                            initialOpenFilterNames={['Tema', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                            getFilterDisplayName={(filterName) => this.getFilterDisplayName(filterName)} 
                            refiners={this.state.filter} 
                            onFilterSelected={this.onFilterChanged.bind(this)} 
                            onAllFilterClicked={this.onAllFilterClicked.bind(this)} 
                            displayFormat={this.state.displayFormat} 
                            hiddenFilterNames={this.state.hiddenFilterNames}
                            totalResults={this.state.allResultsTotalCount} />
                    )}
                    {!isDesktop && numberOfActiveFilters > 0 && (numberOfResults > 0 || this.state.results?.items.length === 0) && !(this.state.searchWithoutFiltersHasResults && this.state.isInitialSearch) && <FiltersSelected filters={getFilterParametersFromUrl(this.refinementFilters)} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} />}
                </div>
                <div className="resultContainer">
                    
                    <div className='filters-and-results'>
                        
                        {isDesktop && (
                            <div className={`${filterClass}`}>
                                {shouldDisplayFilters 
                                    && this.state.filter 
                                        && <Filter 
                                            initialOpenFilterNames={['Tema', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                                            getFilterDisplayName={(filterName) => this.getFilterDisplayName(filterName)} 
                                            refiners={this.state.filter} 
                                            onFilterSelected={this.onFilterChanged.bind(this)} 
                                            onAllFilterClicked={this.onAllFilterClicked.bind(this)} 
                                            displayFormat={this.state.displayFormat} 
                                            hiddenFilterNames={this.state.hiddenFilterNames}
                                            totalResults={this.state.allResultsTotalCount}
                                            filterChips={numberOfActiveFilters > 0 ? <FiltersSelected filters={getFilterParametersFromUrl(this.refinementFilters)} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} /> : undefined} />}
                            </div>
                        )}
                        <div className={`${searchresultsClass}`}>
                            {/* 
                            {numberOfActiveFilters > 0 && shouldDisplayFilters && <span className="emptyFilterLink"><button onClick={() => this.emptyFilters()}>{`Tøm filtre (${numberOfActiveFilters})`}</button></span>}
                            */}
                            
                            <InformationMessageBox
                                isDesktop={isDesktop}
                                currentPage="Forskning"
                                informationMessage={this.state.informationMessage}
                            />
                            
                            <SuggestionBox
                                query = {this.state.query}
                                searchboxQuery = {this.state.searchboxQuery}
                                erronousQuery = {this.state.erronousQuery}
                                querySuggestion = {this.state.querySuggestion}
                                emptyFilters = {() => this.emptyFilters()}
                                initialFilters = {this.state.initialFilters}
                                refinementFilters = {this.refinementFilters}
                                searchWithoutFiltersHasResults = {this.state.searchWithoutFiltersHasResults}
                                isSearchingWithDeactivatedFilters = {this.state.isSearchingWithDeactivatedFilters}
                                results = {this.state.results}
                                predefinedFilterLabel = "gyldig innhold"
                                isInitialSearch = {this.state.isInitialSearch}
                            />
                            {this.state.results && this.state.results.items.length === 0 && this.state.query && (() => {
                                const filterNames = this.state.noResultFilterNames || [];
                                //predefinedFilterLabel="gyldig innhold for regelverk" //Removed param from <NoResultPane>
                                return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={filterNames} refinementFilters={this.refinementFilters}  />
                            })()}
                            {numberOfResults > 0 && (
                            <div className="numresults-sortby">
                                <Resultnumber currentPageNumber={this.state.currentPageNumber} isDesktop={isDesktop} numberOfResults={numberOfResults} resultPerPage={this.resultPerPage} searchQuery={this.state.query} />
                                {/*numberOfResults > 0 && (
                                <div className="results-sortby-suggestion">
                                    <SortBySuggestion
                                        currentTab="regelverk"
                                        searchQuery={this.state.query}
                                        onSortChange={this.onSortChanged}
                                    />
                                </div>
                            )*/}
                            </div>
                            )}
                            
                            
                            {this.state.results && this.state.results.items.length > 0 && <ResultPane results={this.state.results.items as IRegelverkResult[]} queryText={this.state.results.queryText} />}
                            {numberOfPages > 1 && <Pagination currentPage={this.state.currentPageNumber} numberOfPages={numberOfPages} onPageChanged={(newPageNumber) => this.onPageChanged(newPageNumber)} searchQuery={this.state.searchboxQuery} />}
                            {/*<MoveToTop />*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderResultPane() {
        if (!this.state.results) return null
        if (this.state.results.items.length === 0) {
            if (!this.state.query) return null;
            // Use stored filter names from state
            const filterNames = this.state.noResultFilterNames || [];
            return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={filterNames} refinementFilters={this.refinementFilters} predefinedFilterLabel="gyldig innhold" />
        }
        return <ResultPane results={this.state.results.items as IRegelverkResult[]} queryText={this.state.results.queryText} />;
    }

    private getFilterDisplayName(filterName: string) {
        switch(filterName) {
            case 'lover':
                return 'Regelverksområde';
            case 'sidetype':
                return 'Innholdstype';
            case 'innholdstype':
                return 'Innholdstype';
            case 'Tema':
                return 'Regelverksområde';
            case 'gyldighet':
                return 'Gyldighet';
            default:
                return filterName;
        }
    }

    private async setupAndRunInitialQuery() {
        const pageNumber = this.state.initialPageNumber ? this.state.initialPageNumber : 1;
        let initialFilters: any[] | undefined = undefined;
        const initialQuery: string = this.state.initialQuery ? this.state.initialQuery : '*';
        if(initialQuery !== '*') {
            setUrlParameter(document.location.href, this.queryParameter, initialQuery, true);
        }
        if (this.state.initialFilters && this.state.initialFilters.length > 0) {
            initialFilters = getFilterParametersFromUrl(this.refinementFilters);
        }
        this.setState({
            searchboxQuery: initialQuery === '*' ? '' : initialQuery,
            newStateQuery: undefined
        });
        await this.runQuery(initialQuery, false, this.state.searchSource, pageNumber, initialFilters, true);
    }


    private onSearch(query: string, searchAsYouType: boolean) {
        let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
        let searchboxQuery = SearchBox.getSearchBoxQuery();

        let currentPageUrl = getUrlParameter('page');
        if (currentPageUrl) {
            setUrlParameter(window.location.href, 'page', '');
        }

        this.setState({
            query: query,
            searchboxQuery: searchboxQuery,
            currentPageNumber: 1,
            isInitialSearch: false
        });
        
        // When searching with active filters, we want to preserve all filter options
        const hasFilters = urlFilters && urlFilters.length > 0;
        
        if(hasFilters){
            this.runQuery(query, false, this.state.searchSource, 1, urlFilters, false, true); // preserveFilters = true
        }else{
            this.runQuery(query, false, this.state.searchSource, 1);
        }

        //Only update when user have initiated a search from a action, not type as you search
        if(searchAsYouType === true) {
            setUrlParameter(window.location.href, this.queryParameter, query, true);
        } else {
            setUrlParameter(window.location.href, this.queryParameter, query);
        }

    }

    private onSearchClearFilters(query: string) {
        //Clear all the url-params
        this.refinementFilters.forEach(refinementFilter => {
            setUrlParameter(window.location.href, refinementFilter, '');
        });
        this.onSearch(query, false);
    }

    private onPageChanged(newPageNumber: number) {
        let filter = this.state.filter ? this.state.filter : undefined;
        if (this.state.query) {
            this.runQuery(this.state.query, false, this.state.searchSource, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            //Scroll to top
            window.scrollTo(0, 0);
        } else if (this.state.query === "" && this.state.results && this.state.results.totalResults > 10) {
            this.runQuery("*", false, this.state.searchSource, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            window.scrollTo(0, 0);
        }
    }

    private remapFilters(fetchedRefiners: IRefiners[], initFilter: any[] | undefined, selectedFilter: string) {
        if (initFilter && initFilter.length > 0) {
            this.refinementFilters.forEach(filterName => {
                let currentInitFilter = initFilter.filter(val => val.Name === filterName)[0];

                if (currentInitFilter && fetchedRefiners) {
                    let currentFetchedFilter = fetchedRefiners.filter(val => val.Name === filterName)[0];
                    if (currentFetchedFilter) {
                        // Match by token first, then fall back to RefinementValue/RefinementName
                        currentFetchedFilter.Entries.forEach(refiner => {
                            refiner.checked = currentInitFilter.Entries.some(val =>
                                val.RefinementToken === refiner.RefinementToken ||
                                val.RefinementValue === refiner.RefinementValue ||
                                val.RefinementName === refiner.RefinementName
                            );
                        });

                        // If a URL filter entry doesn't match any fetched refiner entry,
                        // add it with count 0 so it appears checked in the filter panel
                        currentInitFilter.Entries.forEach(urlEntry => {
                            const hasMatch = currentFetchedFilter.Entries.some(entry =>
                                entry.RefinementToken === urlEntry.RefinementToken ||
                                entry.RefinementValue === urlEntry.RefinementValue ||
                                entry.RefinementName === urlEntry.RefinementName
                            );
                            if (!hasMatch) {
                                currentFetchedFilter.Entries.push({
                                    RefinementCount: '0',
                                    RefinementName: urlEntry.RefinementName,
                                    RefinementToken: urlEntry.RefinementToken,
                                    RefinementValue: urlEntry.RefinementValue,
                                    checked: true
                                });
                            }
                        });
                    }
                }
            });
        } else {
            // No filters selected - ensure all are unchecked
            if (fetchedRefiners) {
                fetchedRefiners.forEach(refiner => {
                    refiner.Entries.forEach(entry => {
                        entry.checked = false;
                    });
                });
            }
        }
        return fetchedRefiners;
    }

    private async runQuery(queryString: string, isRerun: boolean, source: SearchSource, pageNumber?: number, filter?: IRefiners[], isInitialQuery?: boolean, preserveFilters?: boolean) {
        if(!filter && !preserveFilters){
            filter = undefined; // Don't use old state, use undefined to get fresh refiners
        }
        let _pageNumber = pageNumber !== undefined ? pageNumber : 1;
        let queryObj: SearchQuery = {
            queryString: queryString,
            pageNumber: _pageNumber,
            refiners: filter,
            source: source
        }
        //let results = await getResults(query, _pageNumber, filter);
        let results = await getResults(queryObj);
        
        // Hent totalt antall resultater fra All-kilden
        let queryObjAll: SearchQuery = {
            queryString: queryString,
            pageNumber: 1,
            refiners: filter,
            source: SearchSource.All
        }
        let allResults = await getResultsAll(queryObjAll);
        
        let resultsNoFilter;
        let allResultsNoFilters;
        let useAllResultsNoFilters = false;
        const hasActiveFilters = (filter && filter.length > 0) || (getFilterParametersFromUrl(this.refinementFilters).length > 0);

        // Checking if search should expand with all available filter values
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if(filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all"){
            const query: SearchQuery = {
                queryString: queryString,
                pageNumber: _pageNumber,
                refiners: undefined,  // No filters for showing all available options
                source: source
            };
            allResultsNoFilters = await getResults(query);
            useAllResultsNoFilters = true;
        } else if (preserveFilters && filter) {
            // When preserving filters, we need results without filters to get accurate counts for all options
            const query: SearchQuery = {
                queryString: queryString,
                pageNumber: _pageNumber,
                refiners: undefined,  // No filters for showing all available options
                source: source
            };
            allResultsNoFilters = await getResults(query);
            useAllResultsNoFilters = true;
        }

        // If we have active filters but didn't fetch unfiltered options above, fetch them now
        if (!allResultsNoFilters && hasActiveFilters) {
            const queryAllOptions: SearchQuery = {
                queryString: queryString,
                pageNumber: _pageNumber,
                refiners: undefined,
                source: source
            };
            allResultsNoFilters = await getResults(queryAllOptions);
        }

        if(results.items.length === 0){

            //Run query without any filters
            const queryNoFilters: SearchQuery = {
                queryString: queryString,
                pageNumber: _pageNumber,
                refiners: undefined,
                source: source
            };
            resultsNoFilter = await getResults(queryNoFilters);
        }


        if (results.spellingSuggestion !== undefined && results.spellingSuggestion !== queryObj.queryString && results.spellingSuggestion.length > 0 && results.items.length === 0) {

            // Before using spelling suggestion, check if original query has results without filters
            const urlFilterParams = getFilterParametersFromUrl(this.refinementFilters);
            if (urlFilterParams && urlFilterParams.length > 0 && resultsNoFilter && resultsNoFilter.totalResults > 0) {
                // Original query has results without filters — prefer that over spelling correction
                const hasUserFilters = this.hasUserSelectedFilters();
                if (!hasUserFilters) {
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: queryObj.queryString,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: undefined,
                        erronousQuery: undefined,
                        initialFilters: undefined,
                        allResultsTotalCount: allResults?.totalResults,
                    });
                    return;
                }
            }

            //Run again with querysuggestion

            this.setState({
                querySuggestion: results.spellingSuggestion,
                erronousQuery: queryObj.queryString
            });
            this.runQuery(results.spellingSuggestion, true, source, pageNumber, filter);
            return;

        }  else if(resultsNoFilter && resultsNoFilter.totalResults > 0) {

            // Only auto-fallback to unfiltered results when only predefined filters are active
            // or on initial query. If user has non-predefined filters, don't auto-fallback.
            const hasUserFilters = this.hasUserSelectedFilters();
            if (!isInitialQuery && hasUserFilters) {
                // User has actively chosen filters — show 0 results, no fallback
                // But still set up filter panel from unfiltered results
                const urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                const remapped = this.remapFilters(resultsNoFilter.refiners, urlFilters, "");
                this.setState({
                    filter: remapped,
                    results: results,
                    query: queryObj.queryString,
                    searchWithoutFiltersHasResults: false,
                    querySuggestion: undefined,
                    allResultsTotalCount: allResults?.totalResults,
                });
            } else {
                // Initial query or only predefined filters — fall back to unfiltered results
                removeAllFilterParams(window.location.href, this.refinementFilters);
                const remapped = this.remapFilters(resultsNoFilter.refiners, undefined, "");

                this.setState({
                    filter: remapped,
                    results: resultsNoFilter,
                    query: queryObj.queryString,
                    isSearchingWithDeactivatedFilters: results.items.length > 0,
                    searchWithoutFiltersHasResults: true,
                    querySuggestion: undefined,
                    allResultsTotalCount: allResults?.totalResults,
                    initialFilters: undefined
                });
            }

        }  else {

            // When only predefined filters are active on initial query and both filtered
            // and unfiltered give 0 results, still remove the predefined filters so the user
            // sees "uten filtervalg" instead of "med valgt filter"
            if (results.items.length === 0 && resultsNoFilter && resultsNoFilter.totalResults === 0 && !this.hasUserSelectedFilters()) {
                const hasActiveFiltersInUrl = getFilterParametersFromUrl(this.refinementFilters).length > 0;
                if (hasActiveFiltersInUrl) {
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: queryObj.queryString,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: isRerun ? this.state.querySuggestion : undefined,
                        allResultsTotalCount: allResults?.totalResults,
                        initialFilters: undefined
                    });
                    return;
                }
            }

            //Found results, setting all the proper variables.
            const hasNoFilterResults = allResultsNoFilters && allResultsNoFilters.totalResults > 0;
            const hasFilterResults = results && results.totalResults > 0;
            const onlySearchWithoutFiltersHasResults = hasNoFilterResults && !hasFilterResults;
            
            let setStateObject: any = {
                results: onlySearchWithoutFiltersHasResults ? allResultsNoFilters : results,
                searchWithoutFiltersHasResults: onlySearchWithoutFiltersHasResults,
                currentPageNumber: pageNumber ? pageNumber : 1
            };
            
            // If no results, check if global search has results
            if (results.items.length === 0 && !(resultsNoFilter && resultsNoFilter.totalResults > 0)) {
                // Use the filter parameter passed to runQuery (URL might change during async)
                setStateObject.noResultFilterNames = getFilterNames(filter || []);
            }
            if (preserveFilters) {
                // Base refiners from unfiltered results, apply checked state from URL
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                const base = allResultsNoFilters
                    ? this.remapFilters(allResultsNoFilters.refiners || [], currentFilterParams, "")
                    : this.remapFilters(results.refiners || [], currentFilterParams, "");

                // Disjunctive counts for refiners with checked entries
                const refinersWithSelections = currentFilterParams.filter(r => r.Entries && r.Entries.length > 0);

                for (const refinerWithSelection of refinersWithSelections) {
                    const filtersExcluding = currentFilterParams.filter(f => f.Name !== refinerWithSelection.Name);
                    const queryForRefiner: SearchQuery = {
                        queryString: queryString,
                        pageNumber: 1,
                        refiners: filtersExcluding.length > 0 ? filtersExcluding : undefined,
                        source: source
                    };
                    const resultsForRefiner = await getResults(queryForRefiner);
                    const refinerCounts = resultsForRefiner.refiners?.find(r => r.Name === refinerWithSelection.Name);
                    if (refinerCounts) {
                        const baseRefiner = base.find(r => r.Name === refinerWithSelection.Name);
                        if (baseRefiner) {
                            baseRefiner.Entries.forEach(entry => {
                                const countEntry = refinerCounts.Entries.find(e => e.RefinementToken === entry.RefinementToken);
                                entry.RefinementCount = countEntry ? countEntry.RefinementCount : '0';
                            });
                        }
                    }
                }

                // For refiners WITHOUT selections, use counts from fully filtered results
                setStateObject['filter'] = updateFilterCountsExceptMany(base, results.refiners || [],
                    refinersWithSelections.map(r => r.Name));
            } else if (useAllResultsNoFilters) {
                // filtervalues=all: show all filter options with accurate counts
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                const base = this.remapFilters(allResultsNoFilters.refiners || [], currentFilterParams, "");

                // Disjunctive counts for refiners with checked entries
                const refinersWithSelections = currentFilterParams.filter(r => r.Entries && r.Entries.length > 0);

                for (const refinerWithSelection of refinersWithSelections) {
                    const filtersExcluding = currentFilterParams.filter(f => f.Name !== refinerWithSelection.Name);
                    const queryForRefiner: SearchQuery = {
                        queryString: queryString,
                        pageNumber: 1,
                        refiners: filtersExcluding.length > 0 ? filtersExcluding : undefined,
                        source: source
                    };
                    const resultsForRefiner = await getResults(queryForRefiner);
                    const refinerCounts = resultsForRefiner.refiners?.find(r => r.Name === refinerWithSelection.Name);
                    if (refinerCounts) {
                        const baseRefiner = base.find(r => r.Name === refinerWithSelection.Name);
                        if (baseRefiner) {
                            baseRefiner.Entries.forEach(entry => {
                                const countEntry = refinerCounts.Entries.find(e => e.RefinementToken === entry.RefinementToken);
                                entry.RefinementCount = countEntry ? countEntry.RefinementCount : '0';
                            });
                        }
                    }
                }

                setStateObject['filter'] = updateFilterCountsExceptMany(base, results.refiners || [],
                    refinersWithSelections.map(r => r.Name));
            } else if (isInitialQuery) {
                // Base on unfiltered options (full set), apply URL-checked, then merge counts across all refiners
                const base = allResultsNoFilters ? this.remapFilters(allResultsNoFilters.refiners, this.state.initialFilters, "") : this.remapFilters(results.refiners, this.state.initialFilters, "");
                const merged = updateFilterCounts(base, results.refiners);
                setStateObject['filter'] = merged;
            } else {
                // Base on unfiltered options (if available) and merge counts across all refiners
                const urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                const base = allResultsNoFilters ? this.remapFilters(allResultsNoFilters.refiners, urlFilters, "") : this.remapFilters(results.refiners, urlFilters, "");
                const merged = updateFilterCounts(base, results.refiners);
                setStateObject['filter'] = merged;
            }
            setStateObject['isSearchingWithDeactivatedFilters'] = false;
            setStateObject['query'] = queryObj.queryString;
            if (!isRerun) {
                setStateObject['querySuggestion'] = undefined
            }
            setStateObject['currentPageNumber'] = _pageNumber;
            setStateObject['allResultsTotalCount'] = allResults?.totalResults;
            this.setState(setStateObject);
        }
    }


    private findNumberOfPages() {
        if (!this.state.results || !this.state.results.totalResults) {
            return 1;
        }
        return Math.ceil(this.findNumberOfResults() / this.resultPerPage);
    }

    private findNumberOfResults() {
        if (!this.state.results) {
            return 0;
        }
        return this.state.results.totalResults
    }



    private async onFilterChanged(refinerName: string, refinerIndex: number) {
        let currentFilter = this.state.filter;
        if (!currentFilter) {
            return;
        }
        //let newPreviousFilters = currentFilter.slice();
        let previousFilters = this.state.previousFilters;
        let currentFilterSelection = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries[refinerIndex];
        const newCheckedValue = !currentFilterSelection.checked;

        // Create filtersWithoutChanged BEFORE changing the checked value
        let filtersWithoutChanged = currentFilter.map(f => {
            if (f.Name === refinerName) {
                return {
                    ...f,
                    Entries: f.Entries.map(e => ({ ...e, checked: false }))
                };
            }
            return f;
        });

        currentFilterSelection.checked = newCheckedValue;

        let currentFilterUrlParam = getUrlParameter(refinerName);
        let newFilterParamValue = `${currentFilterSelection.RefinementValue}`;
        let newFilterUrlParam = '';
        if (currentFilterSelection.checked) {
            if (currentFilterUrlParam) {
                newFilterUrlParam = `${currentFilterUrlParam};${newFilterParamValue}`;
            } else {
                newFilterUrlParam = newFilterParamValue;
            }
        } else {
            if (currentFilterUrlParam) {
                newFilterUrlParam = currentFilterUrlParam
                    .split(';')
                    .filter(val => val !== newFilterParamValue)
                    .join(';');
            }
        }
        setUrlParameter(window.location.href, refinerName, newFilterUrlParam);

        const queryString = this.state.query ? this.state.query : '';
        
        // Get results with ALL current filters (after toggle)
        const queryObj: SearchQuery = {
            queryString: queryString,
            pageNumber: 1,
            refiners: currentFilter,
            source: this.state.searchSource
        };
        const newResults = await getResults(queryObj);

        // Also get unfiltered results to preserve full set of filter options
        const queryAllOptions: SearchQuery = {
            queryString: queryString,
            pageNumber: 1,
            refiners: undefined,
            source: this.state.searchSource
        };
        const allResultsNoFilters = await getResults(queryAllOptions);

        // Build base refiners from unfiltered results and apply checked state from URL
        const urlFiltersAfterToggle = getFilterParametersFromUrl(this.refinementFilters);
        let baseRefiners = this.remapFilters(allResultsNoFilters.refiners, urlFiltersAfterToggle, refinerName);

        // Preserve existing counts for the selected refiner from current state before merging
        const currentFilterSelectedNode = currentFilter.filter(val => val.Name === refinerName)[0];
        baseRefiners = ensureSelectedFilterValues(baseRefiners, currentFilterSelectedNode, refinerName);

        // For each refiner with checked entries (other than clicked one), fetch counts with that refiner's filter excluded
        // This implements OR-within-refiner, AND-between-refiners count logic
        const refinersWithSelections = urlFiltersAfterToggle.filter(r => r.Entries && r.Entries.length > 0);
        
        for (const refinerWithSelection of refinersWithSelections) {
            if (refinerWithSelection.Name === refinerName) continue; // Skip clicked refiner, already preserved
            
            // Build filters WITHOUT this refiner
            const filtersWithoutThisRefiner = currentFilter.filter(f => f.Name !== refinerWithSelection.Name);
            
            const queryForRefiner: SearchQuery = {
                queryString: queryString,
                pageNumber: 1,
                refiners: filtersWithoutThisRefiner,
                source: this.state.searchSource
            };
            const resultsForRefiner = await getResults(queryForRefiner);
            
            // Update counts for this refiner from the results
            const refinerCounts = resultsForRefiner.refiners.find(r => r.Name === refinerWithSelection.Name);
            if (refinerCounts) {
                const baseRefiner = baseRefiners.find(r => r.Name === refinerWithSelection.Name);
                if (baseRefiner) {
                    baseRefiner.Entries.forEach(entry => {
                        const countEntry = refinerCounts.Entries.find(e => e.RefinementToken === entry.RefinementToken);
                        entry.RefinementCount = countEntry ? countEntry.RefinementCount : '0';
                    });
                }
            }
        }

        // For refiners WITHOUT selections, use counts from fully filtered results
        const ensuredNextFilter = updateFilterCountsExceptMany(baseRefiners, newResults.refiners, 
            refinersWithSelections.map(r => r.Name));
        
        // If 0 results with filters, check if we should fall back to unfiltered results
        if (newResults.items.length === 0 && allResultsNoFilters.totalResults > 0) {
            // Only auto-fallback when only predefined filters are active.
            // If user has selected non-predefined filters (Tema, innholdstype), show 0 results and let them adjust.
            const hasUserFilters = this.hasUserSelectedFilters();
            if (hasUserFilters) {
                // User has actively chosen filters — show 0 results, no fallback
                this.setState({
                    results: newResults,
                    filter: ensuredNextFilter,
                    currentPageNumber: 1,
                    query: queryString,
                    querySuggestion: undefined,
                    searchWithoutFiltersHasResults: false,
                    isInitialSearch: false
                });
            } else {
                // Only predefined filters — remove them and fall back to unfiltered results
                removeAllFilterParams(window.location.href, this.refinementFilters);
                const remapped = this.remapFilters(allResultsNoFilters.refiners || [], undefined, "");
                this.setState({
                    results: allResultsNoFilters,
                    filter: remapped,
                    currentPageNumber: 1,
                    query: queryString,
                    searchboxQuery: queryString,
                    querySuggestion: undefined,
                    searchWithoutFiltersHasResults: true,
                    isInitialSearch: false
                });
            }
        } else {
            this.setState({
                results: newResults,
                filter: ensuredNextFilter,
                currentPageNumber: 1,
                query: queryString,
                querySuggestion: undefined,
                searchWithoutFiltersHasResults: false,
                isInitialSearch: false
            });
        }
    }

    private async emptyFilters() {
        let refiners = this.state.filter
        if (refiners === undefined) {
            return
        }

        emptyFilterCheckboxes('.filterContainer');

        const filterParams = [...this.refinementFilters, ...[this.refinementFiltersShowAllValuesUrlParamName]];
        removeAllFilterParams(window.location.href, filterParams);

        // Run the query without filters with SearchSource.All to get all filter options
        const query = this.state.query ? this.state.query : "*";

        // Update to All source and show gyldighet filter
        this.setState({
            initialFilters: undefined,
            searchSource: SearchSource.All,
            hiddenFilterNames: []
        });

        // Update URL parameter
        setUrlParameter(window.location.href, 'kilde', 'All');

        this.runQuery(query, false, SearchSource.All);
    }

    private onRemoveFilter = async (filterName: string, filterValue: string) => {
        // Remove filter value from URL
        const currentValue = getUrlParameter(filterName);
        if (currentValue) {
            const newValue = currentValue
                .split(';')
                .filter(v => decodeURIComponent(v) !== filterValue && v !== filterValue)
                .join(';');
            setUrlParameter(window.location.href, filterName, newValue);
        }

        const queryString = this.state.query ? this.state.query : '*';
        const urlFiltersAfterRemoval = getFilterParametersFromUrl(this.refinementFilters);

        // If only predefined filters remain (or no filters), delegate to runQuery
        // which handles predefined filter removal at 0 results
        if (!this.hasUserSelectedFilters()) {
            this.runQuery(queryString, false, this.state.searchSource, 1, urlFiltersAfterRemoval, false, true);
            return;
        }

        // Fetch results with current filters (after removal)
        const newResults = await getResults({
            queryString: queryString,
            pageNumber: 1,
            refiners: urlFiltersAfterRemoval,
            source: this.state.searchSource
        });

        // Also fetch unfiltered options for full option set
        const allResultsNoFilters = await getResults({
            queryString: queryString,
            pageNumber: 1,
            refiners: undefined,
            source: this.state.searchSource
        });

        // Base refiners from unfiltered results, apply checked state from URL
        let baseRefiners = this.remapFilters(allResultsNoFilters.refiners || [], urlFiltersAfterRemoval, filterName);

        // Preserve counts within the affected refiner for entries still checked
        const currentRefinerInState = (this.state.filter || []).find(r => r.Name === filterName);
        const stillCheckedTokens = (urlFiltersAfterRemoval.find(r => r.Name === filterName)?.Entries || []).map(e => e.RefinementToken);
        
        if (currentRefinerInState && stillCheckedTokens.length > 0) {
            // Build a preserved refiner containing only entries still checked after removal
            const preservedRefiner = {
                Name: currentRefinerInState.Name,
                Entries: currentRefinerInState.Entries.filter(e => stillCheckedTokens.includes(e.RefinementToken))
            } as IRefiners;
            baseRefiners = ensureSelectedFilterValues(baseRefiners, preservedRefiner, filterName);
        }

        // Merge counts from filtered results
        let ensuredNextFilter;
        
        // Find refiners that still have checked entries
        const refinersWithCheckedEntries = urlFiltersAfterRemoval
            .filter(r => r.Entries && r.Entries.length > 0);
        
        if (refinersWithCheckedEntries.length > 0) {
            // For each refiner with checked entries, fetch counts with that refiner's filter excluded
            for (const refinerWithSelection of refinersWithCheckedEntries) {
                // Build filters WITHOUT this refiner
                const filtersWithoutThisRefiner = urlFiltersAfterRemoval.filter(f => f.Name !== refinerWithSelection.Name);
                
                const queryForRefiner = {
                    queryString: queryString,
                    pageNumber: 1,
                    refiners: filtersWithoutThisRefiner.length > 0 ? filtersWithoutThisRefiner : undefined,
                    source: this.state.searchSource
                };
                const resultsForRefiner = await getResults(queryForRefiner);
                
                // Update counts for this refiner from the results
                const refinerCounts = resultsForRefiner.refiners?.find(r => r.Name === refinerWithSelection.Name);
                if (refinerCounts) {
                    const baseRefiner = baseRefiners.find(r => r.Name === refinerWithSelection.Name);
                    if (baseRefiner) {
                        baseRefiner.Entries.forEach(entry => {
                            const countEntry = refinerCounts.Entries.find(e => e.RefinementToken === entry.RefinementToken);
                            entry.RefinementCount = countEntry ? countEntry.RefinementCount : '0';
                        });
                    }
                }
            }
            
            // For refiners WITHOUT selections, use counts from fully filtered results
            ensuredNextFilter = updateFilterCountsExceptMany(baseRefiners, newResults.refiners || [], 
                refinersWithCheckedEntries.map(r => r.Name));
        } else {
            // No filters at all - use baseRefiners directly (from unfiltered results)
            ensuredNextFilter = baseRefiners;
        }

        this.setState({
            results: newResults,
            filter: ensuredNextFilter,
            currentPageNumber: 1,
            query: queryString,
            querySuggestion: undefined,
            noResultFilterNames: newResults.items.length === 0 ? getFilterNames(urlFiltersAfterRemoval) : undefined,
            searchWithoutFiltersHasResults: newResults.items.length === 0 ? this.state.searchWithoutFiltersHasResults : false
        });
    }

    private async onAllFilterClicked(refinerName: string) {
        let stateRefiners = this.state.filter;
        
        if (!stateRefiners) return;
        
        let allFilterClickedRefiner = stateRefiners.filter(refiner => refiner.Name === refinerName)[0];
        if (allFilterClickedRefiner !== undefined) {
            const somethingIsChecked = allFilterClickedRefiner.Entries.filter(entry => entry.checked === true).length > 0;
            if (somethingIsChecked) {
                allFilterClickedRefiner.Entries.forEach(refinerValue => {
                    refinerValue.checked = false;
                });
                setUrlParameter(window.location.href, refinerName, '');
                const query = this.state.query ? this.state.query : '';
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                this.runQuery(query, false, this.state.searchSource, 1, urlFilters);
            }
        }
    }

    private onSortChanged = (sortValue: string) => {
        // Re-run query with current filters preserved
        this.runQuery(
            this.state.query ? this.state.query : '', 
            false, 
            this.state.searchSource, 
            1, // Reset to first page
            this.state.filter, // Keep current filters
            false, // isInitialQuery
            true // preserveFilters - keep all filter options visible
        );
    }

    private onStatePopped() {
        const newStateQuery = getUrlParameter(this.queryParameter);
        const initialPageNumber = getUrlParameter('page');
        const safeInitialPageNumber = initialPageNumber ? +initialPageNumber : 1;
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);

        //Set up variables properly (like in the constructor), and run the setupjob
        this.setState({
            newStateQuery: newStateQuery,
            initialQuery: newStateQuery,
            initialPageNumber: safeInitialPageNumber,
            initialFilters: filterParameters,
        }, () => {
            this.setupAndRunInitialQuery();
        });
    }

    private updateSearchSource(source: SearchSource) {
        let filter = this.state.filter ? this.state.filter : undefined;
        const query = this.state.query ? this.state.query : "";
        this.runQuery(query, false, source, 1, filter);
        const newUrlParam = source === SearchSource.All ? source : '';
        setUrlParameter(window.location.href, 'kilde', newUrlParam);
        let hiddenFilterNamesList: string[] = ['gyldighet'];
        if(newUrlParam === "All"){
            hiddenFilterNamesList = []; 
        }
        this.setState({
            searchSource: source,
            hiddenFilterNames: hiddenFilterNamesList
        });
    }

    private _onWindowResize() {
        let currentDisplayFormat = getCurrentDisplayFormat();
        this.setState({ displayFormat: currentDisplayFormat });
    }

    /**
     * Returns true if any non-predefined filter params are set in the URL.
     * Predefined filters (e.g. 'gyldighet') are system-set, not user-selected.
     */
    private hasUserSelectedFilters(): boolean {
        return this.refinementFilters
            .filter(name => !this.predefinedFilterNames.includes(name))
            .some(name => {
                const value = getUrlParameter(name);
                return value !== undefined && value.length > 0;
            });
    }

}
